import React
    , {
    useEffect,
    useState
} from "react";
import ReactDOM
    from "react-dom/client";

import Webform
    from './form-renderer/Webform';
import MuiTheme
    from "@components/providers/MuiTheme";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import BasicTheme
    from "./form-renderer/BasicTheme";
import Box
    from "@mui/material/Box";
import {ErrorOutlineOutlined} from "@mui/icons-material";

export {default as FormSketchInjection } from '../dominjection/form-sketch';


const getOrigin = (origin) => {
    switch (origin) {
        case 'http://localhost:8888/':
        case 'http://formitize.test:8888/':
        case 'https://aus.service.formitize.com/':
        case 'https://staging.formitize.com/':
        case 'https://service.formitize.com.au/':
            return origin;
        default: {
            return 'https://service.formitize.com.au/';
        }
    }
}

const WebformProvider = ({
                             companyID,
                             formID,
                             token,
                             origin,
                             ...rest
                         }) => {
    if (!token) {
        throw new Error("Missing token on Webform");
    }

    if (!formID) {
        throw new Error("Missing Form ID on Webform");
    }

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [template, setTemplate] = useState(null);
    const [submission, setSubmission] = useState(null);

    async function getForm(url = `${origin}api/rest/v2/form/?id=${formID}&wf=true`, data = {}) {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });

        return await response.json(); // parses JSON response into native JavaScript objects
    }

    useEffect(() => {
        getForm().then(async response => {
            if (response.payload) {
                const error = response?.payload?.error;

                if (error) {
                    return setError(error?.message ? error?.message : error);
                }

                if (response.payload.template) {
                    setTemplate(response.payload.template);
                }

                if (response.payload.templateAnswers) {
                    setSubmission(response.payload.templateAnswers);
                }
            }
        }).finally(() => {
            setLoading(false);
        })
    }, []);

    return (
        <MuiTheme theme={BasicTheme}>
            {error &&
            <Box sx={{
                display: 'flex',
                margin: '0 auto',
                maxWidth: 300,
                alignItems: 'center',
                flexDirection: 'column',
                textAlign: 'center'
            }}>
                <div><ErrorOutlineOutlined sx={{fontSize: '40px', mb: 1}} /></div>
                <div>{error}</div>
            </Box>}
            {!error && (
                <GoogleReCaptchaProvider reCaptchaKey="6LeNyUIlAAAAAIQavYlmb7c6wK3HnUrFQFKYKt_s">
                    <div className='fz-form-wrapper'>
                        <Webform loading={loading}
                                 template={template}
                                 submission={submission}
                                 companyID={companyID}
                                 formID={formID}
                                 origin={origin}
                                 {...rest}/>
                    </div>
                </GoogleReCaptchaProvider>
            )}
        </MuiTheme>
    );
}

document.querySelectorAll(".fz-embed-webform").forEach((domContainer) => {
    const root = ReactDOM.createRoot(domContainer);
    const theme = domContainer.getAttribute('data-theme')
    const originUrl = domContainer.getAttribute('data-origin-url');
    const token = domContainer.getAttribute('data-token');
    const formID = domContainer.getAttribute('data-fid');
    const companyID = domContainer.getAttribute('data-cid');

    root.render(
        <WebformProvider origin={originUrl} companyID={companyID} formID={formID} theme={theme && theme} token={token}/>
    );
});

export default WebformProvider;

export {
    getOrigin
}
